import { Component } from '@angular/core';

@Component({
  selector: 'app-receipt-icon',
  templateUrl: './receipt-icon.component.html',
  styleUrl: './receipt-icon.component.scss',
})
export class ReceiptIconComponent {}
